"use client";

import React from "react";
import Link from "next/link";
import { trackEvent, EventProps } from "@/lib/marketing/events";

interface BaseProps {
  eventName: string;
  eventProps?: EventProps;
  children: React.ReactNode;
  className?: string;
}

interface LinkCTAProps extends BaseProps {
  href: string;
  as?: "link";
  target?: string;
  rel?: string;
}

interface ButtonCTAProps extends BaseProps {
  as: "button";
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit";
}

export type TrackedCTAProps = LinkCTAProps | ButtonCTAProps;

/**
 * CTA wrapper that fires a named analytics event before handing off.
 * Use for any conversion-relevant link/button.
 */
export function TrackedCTA(props: TrackedCTAProps) {
  const handle = () => {
    trackEvent(props.eventName, props.eventProps ?? {});
  };

  if (props.as === "button") {
    const { eventName, eventProps, as, onClick, ...rest } = props;
    void eventName; void eventProps; void as;
    return (
      <button
        {...rest}
        onClick={() => { handle(); onClick?.(); }}
      >
        {props.children}
      </button>
    );
  }

  const { eventName, eventProps, as, ...rest } = props;
  void eventName; void eventProps; void as;
  return (
    <Link {...rest} onClick={handle}>
      {props.children}
    </Link>
  );
}
